<template>
  <div class="receivable-data">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="统计月份">
          <el-date-picker
            v-model="searchForm.stat_month"
            type="month"
            placeholder="选择月份"
            value-format="yyyy-MM"
            clearable
          />
        </el-form-item>
        
        <el-form-item label="费项名称">
          <el-input
            v-model="searchForm.charge_item_name"
            placeholder="请输入费项名称"
            clearable
          />
        </el-form-item>
        
        <el-form-item label="费项分类">
          <el-select
            v-model="searchForm.charge_item_class"
            placeholder="请选择分类"
            clearable
          >
            <el-option
              v-for="item in chargeItemClassList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="收费周期">
          <el-date-picker
            v-model="chargePeriodRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button type="success" @click="handleExport">导出Excel</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    
    <!-- 统计汇总 -->
    <!--
    <el-card class="summary-card" shadow="never">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="summary-item">
            <div class="label">总记录数</div>
            <div class="value">{{ summary.total_count || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="summary-item">
            <div class="label">原始应收总额</div>
            <div class="value">¥{{ formatMoney(summary.total_original) }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="summary-item">
            <div class="label">调整金额总额</div>
            <div class="value">¥{{ formatMoney(summary.total_adjust) }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="summary-item">
            <div class="label">最终应收总额</div>
            <div class="value highlight">¥{{ formatMoney(summary.total_receivable) }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    -->
    
    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        :data="tableData"
        v-loading="loading"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
      >
        <el-table-column prop="stat_month" label="统计月份" width="100" >
            <template slot-scope="scope">
              {{ scope.row.stat_year }}-{{ scope.row.stat_month }}
            </template>
        </el-table-column>
        <el-table-column prop="pindex_name" label="项目名称" width="180" show-overflow-tooltip />
        <el-table-column prop="house_address" label="房产地址" width="200" show-overflow-tooltip />
        <el-table-column label="收费周期" width="220">
          <template slot-scope="scope">
            {{ scope.row.charge_period_start }} ~ {{ scope.row.charge_period_end }}
          </template>
        </el-table-column>
        <el-table-column prop="charge_item_name" label="费项名称" width="150" show-overflow-tooltip />
        <el-table-column prop="charge_name" label="收费标准" width="180" show-overflow-tooltip />
        <el-table-column prop="original_amount" label="原始应收" width="120" align="right">
          <template slot-scope="scope">
            ¥{{ formatMoney(scope.row.original_amount) }}
          </template>
        </el-table-column>
        <el-table-column prop="adjust_amount" label="调整金额" width="120" align="right">
          <template slot-scope="scope">
            <span :class="{ 'text-danger': scope.row.adjust_amount < 0 }">
              ¥{{ formatMoney(scope.row.adjust_amount) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="refund_amount" label="退款金额" width="120" align="right">
          <template slot-scope="scope">
            ¥{{ formatMoney(scope.row.refund_amount) }}
          </template>
        </el-table-column>
        <el-table-column prop="receivable_amount" label="最终应收" width="120" align="right">
          <template slot-scope="scope">
            <strong>¥{{ formatMoney(scope.row.receivable_amount) }}</strong>
          </template>
        </el-table-column>
        <el-table-column label="操作轨迹" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="showOperationTrace(scope.row)"
            >
              查看({{ getTraceCount(scope.row) }})
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        v-if="total > 0"
        @current-change="handlePageChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
      />
    </el-card>
    
    <!-- 操作轨迹对话框 -->
    <el-dialog
      title="操作轨迹详情"
      :visible.sync="traceDialogVisible"
      width="800px"
    >
      <el-timeline v-if="currentTrace && currentTrace.length > 0">
        <el-timeline-item
          v-for="(trace, index) in currentTrace"
          :key="index"
          :timestamp="formatTimestamp(trace.operation_time)"
          placement="top"
        >
          <el-card>
            <div><strong>操作类型：</strong>{{ getOperationTypeName(trace.operation_type) }}</div>
            <div><strong>金额：</strong>¥{{ formatMoney(trace.amount) }}</div>
            <div v-if="trace.order_ids"><strong>订单ID：</strong>{{ trace.order_ids }}</div>
            <div v-if="trace.detail_ids"><strong>明细ID：</strong>{{ trace.detail_ids }}</div>
            <div v-if="trace.adjust_type"><strong>调整类型：</strong>{{ trace.adjust_type }}</div>
            <div><strong>说明：</strong>{{ trace.remark }}</div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <div v-else>暂无操作轨迹</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ReceivableData',
  props: {
    // 接收父组件传递的筛选条件
    filterData: {
      type: Object,
      default: () => ({
        pindex_id: '',
        house_id: 0,
        house_address: ''
      })
    }
  },
  data() {
    return {
      searchForm: {
        stat_month: '',
        charge_item_name: '',
        charge_item_class: '',
        charge_period_start: '',
        charge_period_end: ''
      },
      chargePeriodRange: [],
      chargeItemClassList: [],
      tableData: [],
      summary: {},
      loading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableHeight: 500,
      traceDialogVisible: false,
      currentTrace: []
    }
  },
  mounted() {
    this.loadChargeItemClassList()
    this.loadData()
  },
  watch: {
    // 监听filterData变化，自动刷新数据
    filterData: {
      handler() {
        this.currentPage = 1
        this.loadData()
      },
      deep: true
    }
  },
  methods: {
    // 加载费项分类列表
    loadChargeItemClassList() {
      this.$myhttp.get('admin/IncomeController/getChargeItemClassList').then(res => {
        if (res.data.code === 200) {
          this.chargeItemClassList = res.data.data
        }
      })
    },
    
    // 加载数据
    loadData() {
      this.loading = true
      
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchForm,
        // 使用父组件传递的筛选条件
        pindex_id: this.filterData.pindex_id,
        house_id: this.filterData.house_id,
        house_address: this.filterData.house_address
      }
      
      // 处理收费周期范围
      if (this.chargePeriodRange && this.chargePeriodRange.length === 2) {
        params.charge_period_start = this.chargePeriodRange[0]
        params.charge_period_end = this.chargePeriodRange[1]
      }
      
      this.$myhttp.post('admin/IncomeController/getList', params).then(res => {
        this.loading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
          this.loadSummary()
        }
      }).catch(() => {
        this.loading = false
      })
    },
    
    // 加载统计数据
    loadSummary() {
      const params = { ...this.searchForm }
      if (this.chargePeriodRange && this.chargePeriodRange.length === 2) {
        params.charge_period_start = this.chargePeriodRange[0]
        params.charge_period_end = this.chargePeriodRange[1]
      }
      
      this.$myhttp.post('admin/IncomeController/getSummary', params).then(res => {
        if (res.data.code === 200) {
          this.summary = res.data.data
        }
      })
    },
    
    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    
    // 重置
    handleReset() {
      this.searchForm = {
        stat_month: '',
        charge_item_name: '',
        charge_item_class: '',
        charge_period_start: '',
        charge_period_end: ''
      }
      this.chargePeriodRange = []
      this.handleSearch()
    },
    
    // 分页变化
    handlePageChange(page) {
      this.currentPage = page
      this.loadData()
    },
    
    // 导出Excel
    handleExport() {
      const params = { ...this.searchForm }
      if (this.chargePeriodRange && this.chargePeriodRange.length === 2) {
        params.charge_period_start = this.chargePeriodRange[0]
        params.charge_period_end = this.chargePeriodRange[1]
      }
      
      this.$myhttp.post('admin/IncomeController/exportExcel', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        if (res.data.code == 200) {
          let url = res.data.data.url
          window.open(this.$myhttp.defaults.baseURL + url, "_blank")
          this.$message.success('导出成功')
        } else {
          this.$message.error(res.data.message || '导出失败')
        }
      }).catch(() => {
        this.$message.error('请求异常')
      })
    },
    
    // 显示操作轨迹
    showOperationTrace(row) {
      this.currentTrace = row.operation_trace || []
      this.traceDialogVisible = true
    },
    
    // 格式化金额
    formatMoney(value) {
      if (value === null || value === undefined) return '0.00'
      return Number(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    
    // 格式化时间戳
    formatTimestamp(timestamp) {
      if (!timestamp) return '-'
      // 使用Date对象格式化时间戳
      const date = new Date(timestamp * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    
    // 获取操作类型名称
    getOperationTypeName(type) {
      const typeMap = {
        'order_generation': '订单生成',
        'order_cancellation': '订单撤销',
        'order_adjustment': '订单调整',
        'temporary_refund': '临时收费退款',
        'receivable_refund': '应收款跨月退款'
      }
      return typeMap[type] || type
    },
    
    // 获取轨迹数量
    getTraceCount(row) {
      if (!row.operation_trace) return 0
      if (typeof row.operation_trace === 'string') {
        try {
          return JSON.parse(row.operation_trace).length
        } catch (e) {
          return 0
        }
      }
      return Array.isArray(row.operation_trace) ? row.operation_trace.length : 0
    }
  }
}
</script>

<style scoped lang="scss">
.receivable-data {
  .filter-card {
    margin-bottom: 20px;
  }
  
  .summary-card {
    margin-bottom: 20px;
    
    .summary-item {
      text-align: center;
      padding: 15px;
      background: #f5f7fa;
      border-radius: 4px;
      
      .label {
        font-size: 14px;
        color: #909399;
        margin-bottom: 8px;
      }
      
      .value {
        font-size: 20px;
        font-weight: bold;
        color: #303133;
        
        &.highlight {
          color: #409EFF;
        }
      }
    }
  }
  
  .table-card {
    .text-danger {
      color: #F56C6C;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/income/ReceivableData.vue